/* eslint-disable import/prefer-default-export */

export const MONTHS_ITEMS = [
  { id: '01', display: 'January' },
  { id: '02', display: 'February' },
  { id: '03', display: 'March' },
  { id: '04', display: 'April' },
  { id: '05', display: 'May' },
  { id: '06', display: 'June' },
  { id: '07', display: 'July' },
  { id: '08', display: 'August' },
  { id: '09', display: 'September' },
  { id: '10', display: 'October' },
  { id: '11', display: 'November' },
  { id: '12', display: 'December' },
];
